import { AuxEngineReport } from './aux-engine-report';
import { MainEngineReport } from './main-engine-report';

export interface EngineReportsState {
  meReports: MainEngineReport[];
  isExtracting: boolean;
  aeReports: AuxEngineReport[];
}

export const initialEngineReportsState: EngineReportsState = {
  meReports: [],
  isExtracting: false,
  aeReports: [],
};
